/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const PaymentIcon = ({ width, height }) => {
  return (
    <svg
      className="animated"
      id="freepik_stories-completed"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
      `}
    >
      <style
        dangerouslySetInnerHTML={{
          __html:
            'svg#freepik_stories-completed:not(.animated) .animable {opacity: 0;}svg#freepik_stories-completed.animated #freepik--background-complete--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-completed.animated #freepik--Plants--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-completed.animated #freepik--Character--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-completed.animated #freepik--Floor--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-completed.animated #freepik--Ribbon--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-completed.animated #freepik--Confetti--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-completed.animated #freepik--Stars--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-completed.animated #freepik--speech-bubble--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}            @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }        .animator-hidden { display: none; }',
        }}
      />
      <g
        id="freepik--background-complete--inject-3"
        style={{ transformOrigin: '240.12840270996094px 235.22126007080078px' }}
        className="animable"
      >
        <path
          d="M392.25,268.44l-72.73-27.5a9.72,9.72,0,0,1-5.65-12.54l38.06-100.66a9.73,9.73,0,0,1,12.54-5.66l46.13,17.44,21.78,50.3-27.59,73A9.73,9.73,0,0,1,392.25,268.44Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '372.8089027404785px 195.26250457763672px',
          }}
          id="elt8u0uf80i"
          className="animable"
        />
        <path
          d="M410.6,139.52l-10.72,28.33a9.05,9.05,0,0,0,5.26,11.67l27.24,10.3Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '415.8353614807129px 164.67000579833984px',
          }}
          id="elphvlckgenei"
          className="animable"
        />
        <path
          d="M399.31,170.48s-2.95,6.74,4,12a8.27,8.27,0,0,0,.82.54c3.32,2,25.16,15,25.36,14.47l2.88-7.62-27.24-10.3S398.43,176.72,399.31,170.48Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '415.5290298461914px 183.9928731918335px',
          }}
          id="elbtl4e9qp9c8"
          className="animable"
        />
        <path
          d="M394.22,164.39c-.14.37-7.78-2.19-17.07-5.7s-16.71-6.66-16.57-7,7.78,2.19,17.07,5.7S394.36,164,394.22,164.39Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '377.3999900817871px 158.04247665405273px',
          }}
          id="elvsm81qeaqxj"
          className="animable"
        />
        <path
          d="M409.89,188.63c-.14.36-12.64-4-27.93-9.81s-27.58-10.77-27.44-11.14,12.64,4,27.94,9.82S410,188.26,409.89,188.63Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '382.2047863006592px 178.1544599533081px',
          }}
          id="el1hqvkzhjb6f"
          className="animable"
        />
        <path
          d="M409.82,203.89c-.14.36-13.76-4.45-30.43-10.76s-30.07-11.71-29.93-12.07,13.76,4.45,30.43,10.76S410,203.52,409.82,203.89Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '379.6403522491455px 192.47500610351562px',
          }}
          id="elcunf6x1vlxr"
          className="animable"
        />
        <path
          d="M405.05,216.51c-.14.36-13.76-4.45-30.43-10.76S344.55,194,344.69,193.68s13.76,4.45,30.43,10.75S405.19,216.14,405.05,216.51Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '374.8699836730957px 205.09687614440918px',
          }}
          id="el40o432evk7c"
          className="animable"
        />
        <path
          d="M400.28,229.13c-.14.36-13.77-4.45-30.43-10.76s-30.07-11.71-29.94-12.07,13.76,4.45,30.44,10.75S400.41,228.76,400.28,229.13Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '370.0949935913086px 217.7150182723999px',
          }}
          id="el2kl6qk1xyns"
          className="animable"
        />
        <path
          d="M395.5,241.75c-.13.36-13.76-4.46-30.42-10.76S335,219.28,335.14,218.92s13.76,4.45,30.43,10.75S395.64,241.38,395.5,241.75Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '365.31999588012695px 230.3349733352661px',
          }}
          id="elrcy9zpwl0g"
          className="animable"
        />
        <g id="elplsfhzs8iv">
          <rect
            x="70.82"
            y="176.28"
            width="114.31"
            height="158.27"
            rx="6.36"
            style={{
              fill: 'rgb(235, 235, 235)',
              transformOrigin: '127.975px 255.41500000000002px',
              transform: 'rotate(-19.3deg)',
            }}
            className="animable"
          />
        </g>
        <g id="elnjf6mcto4n">
          <rect
            x="79.32"
            y="184.67"
            width="98.27"
            height="144.26"
            style={{
              fill: 'rgb(224, 224, 224)',
              transformOrigin: '128.45499999999998px 256.79999999999995px',
              transform: 'rotate(-19.3deg)',
            }}
            className="animable"
          />
        </g>
        <g id="elx7apf0ihwdo">
          <rect
            x="77.21"
            y="184.1"
            width="98.27"
            height="141.51"
            style={{
              fill: 'rgb(250, 250, 250)',
              transformOrigin: '126.345px 254.855px',
              transform: 'rotate(-19.3deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M196.09,305.39,149.2,171.88l.17.08L56.64,204.45h0l.09-.18c17.48,50.16,33.75,96.49,46.74,133.56l-.15-.07,92.78-32.37L103.39,338l-.11,0,0-.11c-13-37.07-29.22-83.4-46.8-133.55l0-.14.13,0h0l92.74-32.46.13,0,0,.12Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '126.29000473022461px 254.87001037597656px',
          }}
          id="el1ufwvzcgz35"
          className="animable"
        />
        <path
          d="M163.2,316.91s20.65-17.42,24.23-35.56A26.25,26.25,0,0,1,169.77,292S169.36,311,163.2,316.91Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '175.31499481201172px 299.1300048828125px',
          }}
          id="el8ilz8r0n37l"
          className="animable"
        />
        <g id="elqeqjwzcw9ih">
          <rect
            x="81.82"
            y="234.59"
            width="12.01"
            height="12.01"
            rx="3.42"
            style={{
              fill: 'rgb(235, 235, 235)',
              transformOrigin: '87.82499999999999px 240.595px',
              transform: 'rotate(-19.3deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M87.69,242.48h0a.24.24,0,0,1-.22,0l-2.24-1.3a.28.28,0,0,1,.28-.48l2,1.14,2.36-5a.3.3,0,0,1,.38-.14.28.28,0,0,1,.13.38l-2.49,5.32A.26.26,0,0,1,87.69,242.48Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '87.76513576507568px 239.59217071533203px',
          }}
          id="elh6ev6vf7hxr"
          className="animable"
        />
        <path
          d="M151.73,213.4c0,.08-12,4.37-26.89,9.58s-27,9.37-27,9.3,12-4.37,26.9-9.58S151.71,213.33,151.73,213.4Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '124.78499603271484px 222.83999729156494px',
          }}
          id="eloblxvrijcy"
          className="animable"
        />
        <path
          d="M123.45,232.62s-.31.14-.87.36l-2.42.9c-2,.74-4.88,1.75-8,2.85s-6,2.08-8,2.77l-2.45.81a6.46,6.46,0,0,1-.91.26,5.9,5.9,0,0,1,.87-.37l2.42-.89c2-.75,4.88-1.76,8-2.86s6-2.07,8-2.77l2.45-.81A5.48,5.48,0,0,1,123.45,232.62Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '112.125px 236.59498596191406px',
          }}
          id="el098b5o1who3p"
          className="animable"
        />
        <path
          d="M153,217.08c0,.07-12,4.36-26.9,9.57s-27,9.38-27,9.3,12-4.36,26.91-9.57S153,217,153,217.08Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '126.04999923706055px 226.5150022506714px',
          }}
          id="el8pau2wi560a"
          className="animable"
        />
        <g id="elf7du67qdps9">
          <rect
            x="88.79"
            y="254.49"
            width="12.01"
            height="12.01"
            rx="3.42"
            style={{
              fill: 'rgb(235, 235, 235)',
              transformOrigin: '94.795px 260.495px',
              transform: 'rotate(-19.3deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M94.66,262.38h0a.26.26,0,0,1-.23,0l-2.23-1.3a.27.27,0,0,1-.1-.38.27.27,0,0,1,.38-.1l2,1.14,2.36-5.05a.29.29,0,0,1,.37-.14.28.28,0,0,1,.14.37l-2.49,5.33A.29.29,0,0,1,94.66,262.38Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '94.71691226959229px 259.46754145622253px',
          }}
          id="el8lxwk1aj634"
          className="animable"
        />
        <path
          d="M158.7,233.3c0,.08-12,4.36-26.9,9.58s-27,9.37-27,9.3,12-4.37,26.9-9.58S158.68,233.23,158.7,233.3Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '131.75px 242.7400074005127px',
          }}
          id="el46ctwa5d97f"
          className="animable"
        />
        <path
          d="M130.42,252.52s-.31.14-.88.36l-2.41.9c-2,.74-4.88,1.75-8,2.85s-6,2.08-8,2.77l-2.45.81a6.46,6.46,0,0,1-.91.26,5.32,5.32,0,0,1,.87-.37l2.42-.89c2-.75,4.88-1.76,8-2.86s6-2.07,8-2.77l2.45-.81A5.48,5.48,0,0,1,130.42,252.52Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '119.0949935913086px 256.49498748779297px',
          }}
          id="elck92hqoa7hd"
          className="animable"
        />
        <path
          d="M160,237c0,.07-12,4.36-26.9,9.57s-27,9.38-27,9.3,12-4.36,26.9-9.57S160,236.9,160,237Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '133.0500030517578px 246.43469333648682px',
          }}
          id="elsbtit2a7g3k"
          className="animable"
        />
        <g id="el27y2ml17op3">
          <rect
            x="95.76"
            y="274.39"
            width="12.01"
            height="12.01"
            rx="3.42"
            style={{
              fill: 'rgb(235, 235, 235)',
              transformOrigin: '101.765px 280.395px',
              transform: 'rotate(-19.3deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M101.63,282.28h0a.26.26,0,0,1-.23,0L99.16,281a.28.28,0,1,1,.28-.48l2,1.14,2.36-5.05a.28.28,0,1,1,.51.23l-2.49,5.33A.33.33,0,0,1,101.63,282.28Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '101.66504168510437px 279.3703782558441px',
          }}
          id="elt7x2l775sgi"
          className="animable"
        />
        <path
          d="M165.67,253.2c0,.08-12,4.36-26.9,9.58s-27,9.37-27,9.29,12-4.36,26.91-9.57S165.64,253.13,165.67,253.2Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '138.72000122070312px 262.63513565063477px',
          }}
          id="elr4sk83u8mrd"
          className="animable"
        />
        <path
          d="M137.39,272.41a6.46,6.46,0,0,1-.88.37l-2.42.9c-2,.74-4.87,1.75-8,2.85s-6,2.07-8,2.77l-2.45.81a6.93,6.93,0,0,1-.91.26,5.32,5.32,0,0,1,.87-.37l2.42-.9c2-.74,4.88-1.75,8-2.85s6-2.07,8-2.77l2.44-.81A8.53,8.53,0,0,1,137.39,272.41Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '126.06000137329102px 276.38999938964844px',
          }}
          id="elyjaaq96z0e"
          className="animable"
        />
        <path
          d="M167,256.88c0,.07-12,4.36-26.9,9.57s-27,9.38-27,9.3,12-4.36,26.9-9.58S166.93,256.8,167,256.88Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '140.0500030517578px 266.31500816345215px',
          }}
          id="elff14zv0wbo6"
          className="animable"
        />
        <g id="elfegpk9hsw7">
          <rect
            x="102.73"
            y="294.29"
            width="12.01"
            height="12.01"
            rx="3.42"
            style={{
              fill: 'rgb(235, 235, 235)',
              transformOrigin: '108.735px 300.295px',
              transform: 'rotate(-19.3deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M108.59,302.18h0a.28.28,0,0,1-.22,0l-2.24-1.3a.28.28,0,1,1,.29-.48l2,1.14,2.36-5a.28.28,0,0,1,.37-.14.29.29,0,0,1,.14.37l-2.5,5.33A.29.29,0,0,1,108.59,302.18Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '108.65234446525574px 299.2889094352722px',
          }}
          id="eltktardwm3dd"
          className="animable"
        />
        <path
          d="M172.64,273.1c0,.08-12,4.36-26.9,9.57s-27,9.38-27,9.3,12-4.36,26.9-9.57S172.61,273,172.64,273.1Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '145.69000244140625px 282.534707069397px',
          }}
          id="elfc69wyrm3m"
          className="animable"
        />
        <path
          d="M144.35,292.31a5.32,5.32,0,0,1-.87.37l-2.42.9c-2,.74-4.88,1.75-8,2.85s-6,2.07-8,2.77l-2.45.81c-.58.18-.91.27-.91.26a5.32,5.32,0,0,1,.87-.37l2.42-.9c2-.74,4.88-1.75,8-2.85s6-2.07,8-2.77l2.45-.81A6.93,6.93,0,0,1,144.35,292.31Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '133.02500915527344px 296.29035210609436px',
          }}
          id="ellmz2u1p5gda"
          className="animable"
        />
        <path
          d="M173.93,276.78c0,.07-12,4.36-26.9,9.57s-27,9.37-27,9.3,12-4.36,26.9-9.58S173.9,276.7,173.93,276.78Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '146.97999572753906px 286.2148714065552px',
          }}
          id="elmx9yy8oeke"
          className="animable"
        />
        <path
          d="M67.09,191.3l2.44,7a7.79,7.79,0,0,0,9.92,4.78l51.3-18a7.77,7.77,0,0,0,4.77-9.91l-2.44-7Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '101.52441024780273px 185.8437328338623px',
          }}
          id="eljxlrmgtcf6"
          className="animable"
        />
        <path
          d="M100.77,181.82a7.3,7.3,0,1,1,4.47-9.29A7.3,7.3,0,0,1,100.77,181.82Zm-3.9-11.13a4.5,4.5,0,1,0,5.73,2.76A4.5,4.5,0,0,0,96.87,170.69Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '98.34710788726807px 174.93381690979004px',
          }}
          id="elrjqtu7jm2yr"
          className="animable"
        />
        <path
          d="M141.77,200c0,.13-13.48,5-30.21,10.85s-30.33,10.5-30.38,10.37,13.48-5,30.21-10.85S141.72,199.83,141.77,200Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '111.47493743896484px 210.6090850830078px',
          }}
          id="elbvagrkysc9w"
          className="animable"
        />
        <path
          d="M124.44,202.45c0,.13-5.9,2.34-13.29,4.93S97.73,212,97.68,211.82s5.91-2.34,13.3-4.93S124.4,202.32,124.44,202.45Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '111.05984497070312px 207.1375241279602px',
          }}
          id="elo8ebmliini"
          className="animable"
        />
      </g>
      <g
        id="freepik--Plants--inject-3"
        style={{ transformOrigin: '245.9836883544922px 414.7487030029297px' }}
        className="animable"
      >
        <path
          d="M391,405.08a19,19,0,0,1,11.81-1.43c2.14.35,4.38,1,5.83,2.6s1.74,4.44.06,5.82A5.55,5.55,0,0,1,405,413c-3.13,0-6.59-.59-9.08,1.29-1.43,1.07-2.37,2.85-4.07,3.38a4,4,0,0,1-4.43-2,6.89,6.89,0,0,1-.5-5.07A7.74,7.74,0,0,1,391,405.08Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '398.2491807937622px 410.5268840789795px',
          }}
          id="el8ali8sb2kaf"
          className="animable"
        />
        <path
          d="M382.72,389.2c2.2,3.13,6.47,2.1,8.45.18s2.81-4.69,3.57-7.33c1.74-6.05,3.5-12.39,2.21-18.55a10.34,10.34,0,0,0-2.37-5,5.39,5.39,0,0,0-5.1-1.7c-2.16.57-3.49,2.68-4.46,4.68a44.23,44.23,0,0,0-4.37,19c0,3.06.35,6.26,2.07,8.79"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '389.0221061706543px 373.9445037841797px',
          }}
          id="eljmzcnfzzdp"
          className="animable"
        />
        <path
          d="M376.69,393.7a11.41,11.41,0,0,0,1.78-10.51,20.26,20.26,0,0,0-6.22-9,33.49,33.49,0,0,0-11.14-6.57,11.85,11.85,0,0,0-5-.85,5.24,5.24,0,0,0-4.2,2.54c-1.18,2.24,0,4.95,1.16,7.16a83.88,83.88,0,0,0,7.32,11.14c2.19,2.83,4.7,5.62,8.05,6.9s6.81,1.12,8.58-1.19"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '365.2319087982178px 381.03310108184814px',
          }}
          id="elfh4qgwruloi"
          className="animable"
        />
        <path
          d="M382.58,436.51a7.28,7.28,0,0,0,.19-1.42c.11-1,.23-2.34.38-3.89a54.43,54.43,0,0,1,.88-5.71,43.74,43.74,0,0,1,2.07-6.73,24.87,24.87,0,0,1,3.44-6.09,12.86,12.86,0,0,1,4.35-3.62,12.1,12.1,0,0,1,3.66-1.14,6.88,6.88,0,0,0,1.42-.2,6.77,6.77,0,0,0-1.45,0,11.24,11.24,0,0,0-3.81,1,12.79,12.79,0,0,0-4.59,3.64,24.44,24.44,0,0,0-3.56,6.22,40.42,40.42,0,0,0-2.06,6.84,48.85,48.85,0,0,0-.76,5.78c-.13,1.65-.17,3-.19,3.91A6,6,0,0,0,382.58,436.51Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '390.7460517883301px 422.09050941467285px',
          }}
          id="el3btbigvkmes"
          className="animable"
        />
        <path
          d="M382.84,433.52a2.44,2.44,0,0,0,0-.66V431c0-1.64,0-4,.08-7,.15-5.87.65-12.18,1.63-21.08.92-8.37,2.16-18.11,3.47-24.44.28-1.44.56-2.74.83-3.87s.47-2.12.68-2.91.32-1.36.44-1.84a5,5,0,0,0,.12-.66,2.86,2.86,0,0,0-.23.62c-.15.48-.33,1.08-.55,1.82s-.5,1.76-.78,2.89-.61,2.42-.92,3.86A217.39,217.39,0,0,0,384,401.09c-1,8.92-1.42,17-1.45,22.92,0,2.94,0,5.32.1,7,0,.77.08,1.4.11,1.89A3.55,3.55,0,0,0,382.84,433.52Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '386.3199920654297px 401.36000061035156px',
          }}
          id="ell5dewe7z2bb"
          className="animable"
        />
        <path
          d="M382.88,417.86a12,12,0,0,0,0-2,53.53,53.53,0,0,0-.61-5.35,69,69,0,0,0-1.74-7.8,63.14,63.14,0,0,0-3.26-9.23,49.27,49.27,0,0,0-9.57-14.91,24.39,24.39,0,0,0-2.26-2.09c-.34-.3-.65-.59-1-.82l-.87-.6a11.16,11.16,0,0,0-1.67-1.06,56.21,56.21,0,0,1,5.45,4.86,51.4,51.4,0,0,1,9.34,14.86,72.43,72.43,0,0,1,3.28,9.14,75.06,75.06,0,0,1,1.85,7.72c.41,2.23.65,4,.79,5.3A13.61,13.61,0,0,0,382.88,417.86Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '372.41087341308594px 395.9299774169922px',
          }}
          id="elcwq3y1ckhah"
          className="animable"
        />
        <polygon
          points="367.74 445.49 369.31 466.99 396.94 466.99 398.5 445.49 367.74 445.49"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '383.1199951171875px 456.239990234375px',
          }}
          id="eld3zw4lmpgwo"
          className="animable"
        />
        <rect
          x="365.08"
          y="437.01"
          width="36.73"
          height="8.48"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '383.445px 441.25px',
          }}
          id="elahixnupxyle"
          className="animable"
        />
        <polygon
          points="365.08 466.17 365.08 468.51 366.8 468.51 401.19 468.51 401.19 466.17 365.08 466.17"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '383.13499450683594px 467.3400115966797px',
          }}
          id="elwq9h35adbx"
          className="animable"
        />
        <polygon
          points="368.49 472.65 366.8 468.51 399.88 468.51 397.9 472.65 368.49 472.65"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '383.3399963378906px 470.5800018310547px',
          }}
          id="elyowo4zmgrtl"
          className="animable"
        />
        <path
          d="M398,452.51s0,.08-.13.2l-.41.55-1.61,2.06-.07.09-.07-.1-3.95-5.46H392l-3.9,5.51-.12.17-.14-.16-4.61-5.5h.26l-.25.32-4.13,5.17-.13.18-.13-.18c-1.4-2-2.71-3.84-3.9-5.51h.23l-4.79,5.46-.09.1-.07-.11c-.63-1.06-1.13-1.91-1.5-2.52l-.38-.67a1,1,0,0,1-.12-.24s.06.06.16.21l.43.65,1.57,2.47h-.15l4.72-5.53.12-.14.11.15,3.93,5.49h-.27L383,450l.26-.32.13-.17.13.16,4.61,5.51h-.26l3.93-5.49.11-.16.12.16c1.55,2.23,2.88,4.12,3.87,5.53h-.15l1.68-2,.45-.52Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '383.11500549316406px 452.52500915527344px',
          }}
          id="elldaq7d6p19"
          className="animable"
        />
        <path
          d="M398.89,445.34c0,.1-6.92.18-15.46.18s-15.46-.08-15.46-.18,6.92-.17,15.46-.17S398.89,445.25,398.89,445.34Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '383.4300231933594px 445.34498596191406px',
          }}
          id="elr5lcldzck5d"
          className="animable"
        />
        <path
          d="M400.29,468.75c0,.09-7.53.17-16.8.17s-16.8-.08-16.8-.17,7.52-.18,16.8-.18S400.29,468.65,400.29,468.75Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '383.4900207519531px 468.74501037597656px',
          }}
          id="elnyw5ebew1e"
          className="animable"
        />
        <path
          d="M127.8,400.15c-.08.09-.71-.29-1.41-.85s-1.21-1.09-1.13-1.19.7.29,1.4.85S127.87,400.05,127.8,400.15Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '126.52908492088318px 399.1287623643875px',
          }}
          id="el06dzm0dkyqw"
          className="animable"
        />
        <path
          d="M147,371.51a21.88,21.88,0,0,0-.65-7.95c-.84-2.55-2.8-4.88-5.42-5.43-3-.62-6.06,1.27-7.74,3.83s-2.25,5.66-2.75,8.67a306.4,306.4,0,0,0-3.75,62.95l12.24,1.72C144.26,413.33,146,394.12,147,371.51Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '136.75602912902832px 396.65571212768555px',
          }}
          id="eladu8d0blfjr"
          className="animable"
        />
        <path
          d="M139.18,358l-.06.2-.2.55-.82,2.12c-.17.46-.4,1-.58,1.53l-.59,1.85-.69,2.13-.63,2.43A106,106,0,0,0,133.24,381c-.66,4.6-1.09,9.7-1.44,15.06-.62,10.73-.72,20.47-1,27.51-.13,3.53-.25,6.38-.38,8.34-.07,1-.12,1.71-.16,2.27,0,.23,0,.43,0,.58s0,.2,0,.2,0-.06,0-.2,0-.35,0-.59c0-.55,0-1.31.07-2.27.08-2,.15-4.81.24-8.34.2-7,.25-16.78.88-27.52.34-5.37.79-10.48,1.47-15.1a100.76,100.76,0,0,1,2.47-12.14l.66-2.43q.39-1.12.72-2.13l.64-1.85c.19-.56.43-1.06.61-1.52l.9-2.08q.14-.33.24-.54A.76.76,0,0,1,139.18,358Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '134.7199935913086px 396.47998046875px',
          }}
          id="elafq6mjvjijh"
          className="animable"
        />
        <path
          d="M140.31,358.05a8.83,8.83,0,0,1,1.5,2.53,18.73,18.73,0,0,1,1.11,7.92c-.32,6.77-.93,16.09-1.73,26.39s-1.71,19.6-2.43,26.33c-.37,3.36-.68,6.08-.91,8-.12.91-.21,1.63-.28,2.16l-.08.56a1.3,1.3,0,0,1,0,.19s0-.06,0-.19,0-.34,0-.57c0-.53.11-1.25.19-2.17.19-1.92.45-4.63.77-8,.64-6.74,1.49-16,2.3-26.34s1.46-19.61,1.86-26.36a19.12,19.12,0,0,0-1-7.85A16.42,16.42,0,0,0,140.31,358.05Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '140.23196125030518px 395.0899963378906px',
          }}
          id="elilbd83zdom"
          className="animable"
        />
        <path
          d="M148.8,389.74a6.67,6.67,0,0,1-2.32-.6,6.78,6.78,0,0,1-2.17-1,6.41,6.41,0,0,1,2.32.6A6.67,6.67,0,0,1,148.8,389.74Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '146.55500030517578px 388.9399871826172px',
          }}
          id="el6ap8imykhjc"
          className="animable"
        />
        <path
          d="M150.28,377.26a7.64,7.64,0,0,1-2.21,1.23,7.41,7.41,0,0,1-2.39.83,14.59,14.59,0,0,1,4.6-2.06Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '147.97999572753906px 378.2900085449219px',
          }}
          id="elyq0zikfktyh"
          className="animable"
        />
        <path
          d="M149.51,367.07a7.4,7.4,0,0,1-3.62-.25,4,4,0,0,1,1.82-.09A4,4,0,0,1,149.51,367.07Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '147.6999969482422px 366.92652598023415px',
          }}
          id="el2u8mkzhsy5z"
          className="animable"
        />
        <path
          d="M136.87,360.55c-.1.06-.64-.61-1.19-1.49a4.41,4.41,0,0,1-.83-1.73c.1-.06.64.6,1.2,1.49S137,360.48,136.87,360.55Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '135.87254631519318px 358.93996357917786px',
          }}
          id="elkebjztjc0v9"
          className="animable"
        />
        <path
          d="M132.7,366.71a3.65,3.65,0,0,1-1.74.18,3.61,3.61,0,0,1-1.73-.26,3.65,3.65,0,0,1,1.74-.18A3.61,3.61,0,0,1,132.7,366.71Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '130.9649887084961px 366.6700030565262px',
          }}
          id="el6ovsty5svgo"
          className="animable"
        />
        <path
          d="M129.7,379a4.22,4.22,0,0,1-1.83-.5,4.32,4.32,0,0,1-1.67-.91,4.22,4.22,0,0,1,1.83.5A4.32,4.32,0,0,1,129.7,379Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '127.94999694824219px 378.2950134277344px',
          }}
          id="elpd4istv9dbn"
          className="animable"
        />
        <path
          d="M129.38,389.39c0,.12-.67.37-1.56.55s-1.62.25-1.65.13.68-.37,1.56-.55A3.38,3.38,0,0,1,129.38,389.39Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '127.77454829216003px 389.7358318269253px',
          }}
          id="el8q9lhdwbe2w"
          className="animable"
        />
        <path
          d="M128,406.35c0,.12-.72.35-1.66.52a3.6,3.6,0,0,1-1.73.08,3.66,3.66,0,0,1,1.66-.51A3.53,3.53,0,0,1,128,406.35Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '126.30499649047852px 406.6509188115597px',
          }}
          id="elcbuk4cwcr4"
          className="animable"
        />
        <path
          d="M127,415.71c.06.1-.56.54-1.38,1s-1.53.7-1.58.59.56-.54,1.38-1S127,415.6,127,415.71Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '125.52057111263275px 416.5049872994423px',
          }}
          id="elkr1ya2ymub"
          className="animable"
        />
        <path
          d="M134.67,426.33c-.1.06-.64-.68-1.2-1.66a4.82,4.82,0,0,1-.82-1.88c.1-.06.64.68,1.2,1.66A4.82,4.82,0,0,1,134.67,426.33Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '133.66000366210938px 424.55996918678284px',
          }}
          id="elx26bdgi8bj"
          className="animable"
        />
        <path
          d="M136.88,408.68c.08.08-.52.81-1.34,1.62s-1.56,1.39-1.65,1.3.52-.81,1.34-1.62S136.79,408.59,136.88,408.68Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '135.38417434692383px 410.13997507095337px',
          }}
          id="elhxnwkvtoqwk"
          className="animable"
        />
        <path
          d="M136.39,399.41c-.09.09-.64-.37-1.24-1s-1-1.24-.92-1.32.64.37,1.24,1S136.48,399.33,136.39,399.41Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '135.31111228466034px 398.2510230541229px',
          }}
          id="elw2brr8ggjqk"
          className="animable"
        />
        <path
          d="M137.91,387.58c.09.08-.41.79-1.12,1.57s-1.35,1.37-1.44,1.29.41-.79,1.11-1.58S137.82,387.5,137.91,387.58Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '136.62999546527863px 389.00989401340485px',
          }}
          id="eloe9rx4hi8z"
          className="animable"
        />
        <path
          d="M138.76,379c-.09.09-.78-.46-1.56-1.22s-1.33-1.45-1.25-1.54.78.46,1.56,1.23S138.84,378.91,138.76,379Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '137.3549997806549px 377.6199963092804px',
          }}
          id="el2a7xle6jls"
          className="animable"
        />
        <path
          d="M140.44,367.38a4.39,4.39,0,0,1-.79,1.74c-.53.9-1.05,1.58-1.15,1.52s.24-.84.78-1.74S140.33,367.32,140.44,367.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '139.4613047838211px 369.0099856853485px',
          }}
          id="elc3miigso14"
          className="animable"
        />
        <path
          d="M143.59,356.62c.11.06-.2.84-.69,1.74s-1,1.59-1.08,1.54a4.17,4.17,0,0,1,.69-1.74C143,357.25,143.48,356.57,143.59,356.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '142.7160837650299px 358.2599710226059px',
          }}
          id="ellnc365blrrd"
          className="animable"
        />
        <path
          d="M147.17,361.51c.05.11-.44.45-1.1.77s-1.23.48-1.28.37.44-.45,1.1-.77S147.12,361.4,147.17,361.51Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '145.9799964427948px 362.08000338077545px',
          }}
          id="eli5oi54rlrjf"
          className="animable"
        />
        <path
          d="M147.25,400.15a7.48,7.48,0,0,1-4.47-1.91,12.44,12.44,0,0,1,2.25.93A11.87,11.87,0,0,1,147.25,400.15Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '145.01499938964844px 399.1949920654297px',
          }}
          id="elr3hdmcenrkd"
          className="animable"
        />
        <path
          d="M145.79,408.33c0,.12-.71.36-1.65.54a3.55,3.55,0,0,1-1.73.11,3.75,3.75,0,0,1,1.65-.54C145,408.26,145.77,408.21,145.79,408.33Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '144.0999984741211px 408.6519824564457px',
          }}
          id="eltr25aaof3p"
          className="animable"
        />
        <path
          d="M144,422.36c-.07.1-1-.55-1.86-1.63a4.87,4.87,0,0,1-1.17-2.19,13.86,13.86,0,0,1,1.51,1.92A13.23,13.23,0,0,1,144,422.36Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '142.48500061035156px 420.45503079891205px',
          }}
          id="elxa2i9kj9z"
          className="animable"
        />
        <path
          d="M124.31,428.78c-.08-.09.42-.65,1.11-1.24s1.32-1,1.4-.9-.42.64-1.11,1.24S124.39,428.87,124.31,428.78Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '125.56499981880188px 427.70892202854156px',
          }}
          id="elfq0qjm2t1fh"
          className="animable"
        />
        <path
          d="M118.65,398.16c-.8-2.49-2.29-5.39-4.9-5.43a4.34,4.34,0,0,0-3.68,2.46,9,9,0,0,0-1,4.5,117.56,117.56,0,0,0,5.61,32.62h9.57A113.87,113.87,0,0,0,118.65,398.16Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '116.65634727478027px 412.52001953125px',
          }}
          id="elbkbweoeogyn"
          className="animable"
        />
        <path
          d="M101.36,382.49a10.62,10.62,0,0,0-10-8.5c-4.23.74-5.87,4.9-6.37,9.16s.82,8.5,2.13,12.59q6.28,19.68,12.58,39.37l11.9-1.3C107.88,416.23,105.72,399.93,101.36,382.49Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '98.24082946777344px 404.54998779296875px',
          }}
          id="el3t23fionvbf"
          className="animable"
        />
        <path
          d="M113.75,392.73a8.92,8.92,0,0,0-.81,1.35,8.81,8.81,0,0,0-.45,4.23c.18,1.82.39,4,.7,6.4s.74,5,1.28,7.78c1.08,5.5,2.3,10.42,3.07,14,.39,1.79.69,3.25.87,4.26.08.47.15.85.2,1.17s.06.41,0,.41a2.21,2.21,0,0,1-.12-.39l-.28-1.15c-.26-1.07-.6-2.5-1-4.23-.85-3.58-2.12-8.49-3.2-14-.54-2.76-1-5.4-1.25-7.82-.16-1.2-.26-2.36-.36-3.43s-.2-2.08-.25-3a8.68,8.68,0,0,1,.6-4.32A3.74,3.74,0,0,1,113.75,392.73Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '115.37152290344238px 412.53001403808594px',
          }}
          id="el34n701w88y1"
          className="animable"
        />
        <path
          d="M91.58,373.65a15.21,15.21,0,0,0-1.44,1.93,13.65,13.65,0,0,0-1.81,6.23,29,29,0,0,0,1.47,9.57c1,3.54,2.19,7.43,3.4,11.5,2.37,8.16,4.51,15.54,6.08,20.93l1.8,6.36c.2.72.35,1.29.47,1.73a2.87,2.87,0,0,1,.13.61,3.24,3.24,0,0,1-.22-.58c-.13-.44-.32-1-.54-1.72-.47-1.53-1.13-3.68-1.93-6.31L92.78,403c-1.2-4.09-2.33-8-3.37-11.52a28.56,28.56,0,0,1-1.39-9.7,13.37,13.37,0,0,1,2-6.3A7.31,7.31,0,0,1,91.58,373.65Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '94.84354734420776px 403.0799865722656px',
          }}
          id="el9esch53gorp"
          className="animable"
        />
        <path
          d="M109.05,432.54a5.58,5.58,0,0,1-.27-.57c-.15-.39-.4-.94-.67-1.68-.57-1.46-1.3-3.61-2-6.31s-1.5-6-2.22-9.6-1.44-7.63-2.24-11.83-1.74-8.15-2.81-11.68a66.17,66.17,0,0,0-3.47-9.17,49.29,49.29,0,0,0-3.21-5.78c-.41-.66-.78-1.15-1-1.49a3.69,3.69,0,0,1-.33-.54,3.69,3.69,0,0,1,.4.48c.25.34.64.8,1.07,1.46a42.52,42.52,0,0,1,3.35,5.74,61.28,61.28,0,0,1,3.57,9.18A115.78,115.78,0,0,1,102,402.47c.79,4.19,1.53,8.19,2.21,11.84s1.4,6.88,2.12,9.59,1.39,4.86,1.91,6.33c.24.75.47,1.31.6,1.7A2.87,2.87,0,0,1,109.05,432.54Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '99.94001007080078px 403.21502685546875px',
          }}
          id="elqkcvmkctzxp"
          className="animable"
        />
        <path
          d="M87.38,393.78c0,.11-.62.37-1.45.57s-1.52.27-1.54.15.61-.37,1.44-.57S87.35,393.66,87.38,393.78Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '85.88476467132568px 394.139991492033px',
          }}
          id="elape02aytb2e"
          className="animable"
        />
        <path
          d="M86.12,385.66a6.14,6.14,0,0,1-2,.22,5.91,5.91,0,0,1-2-.06,4,4,0,0,1,2-.38A4,4,0,0,1,86.12,385.66Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '84.12000274658203px 385.66805294156075px',
          }}
          id="el4yxuawcvl8f"
          className="animable"
        />
        <path
          d="M87.46,378.24c-.08.1-.73-.32-1.44-.93s-1.24-1.18-1.16-1.27.72.32,1.44.93S87.54,378.15,87.46,378.24Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '86.16005861759186px 377.14116382598877px',
          }}
          id="elrfb7c88120p"
          className="animable"
        />
        <path
          d="M91.09,371.38c.12,0,.08.61.07,1.3s0,1.28-.15,1.3-.31-.56-.29-1.31S91,371.35,91.09,371.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '90.94636508822441px 372.67968010902405px',
          }}
          id="elge8sy8xj94"
          className="animable"
        />
        <path
          d="M98.5,374.61c.1.07-.19.66-.65,1.31s-.91,1.13-1,1.06.19-.65.64-1.31S98.4,374.54,98.5,374.61Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '97.67645806074142px 375.79492807388306px',
          }}
          id="elzedar67usu9"
          className="animable"
        />
        <path
          d="M103.31,383c0,.12-.57.47-1.37.8s-1.5.5-1.54.39.57-.47,1.37-.79S103.27,382.86,103.31,383Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '101.85406410694122px 383.5901827812195px',
          }}
          id="elnf0zsikf1xq"
          className="animable"
        />
        <path
          d="M106.23,391.57a3.49,3.49,0,0,1-1.88.83,3.74,3.74,0,0,1-2.06.07,7.8,7.8,0,0,1,2-.5A8.16,8.16,0,0,1,106.23,391.57Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '104.260009765625px 392.0759076476097px',
          }}
          id="elhirveaaonnb"
          className="animable"
        />
        <path
          d="M92.83,389.13c-.11,0,0-.63.19-1.33s.49-1.23.6-1.19,0,.63-.19,1.33S93,389.17,92.83,389.13Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '93.22500532865524px 387.86999773979187px',
          }}
          id="elk8p2io8ao7"
          className="animable"
        />
        <path
          d="M94.7,399.93a4.12,4.12,0,0,1,.54-1.79c.41-.94.83-1.66.94-1.61a4.12,4.12,0,0,1-.54,1.79C95.23,399.26,94.81,400,94.7,399.93Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '95.43999862670898px 398.2310765981674px',
          }}
          id="elpbmlcjzlwis"
          className="animable"
        />
        <path
          d="M90.08,402.89a4.53,4.53,0,0,1-1.71-.38c-.91-.29-1.65-.55-1.62-.67a3.32,3.32,0,0,1,1.75.25C89.43,402.38,90.13,402.78,90.08,402.89Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '88.41582357883453px 402.35151290893555px',
          }}
          id="elrnv84ebn7go"
          className="animable"
        />
        <path
          d="M92.74,411.69c.07.1-.44.58-1.13,1.08s-1.33.82-1.4.73.44-.59,1.14-1.09S92.67,411.59,92.74,411.69Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '91.47500026226044px 412.59343153238297px',
          }}
          id="elcqn6fpfwwuo"
          className="animable"
        />
        <path
          d="M94.88,420.47c0,.11-.6.37-1.41.56s-1.48.26-1.51.15.6-.37,1.41-.57S94.85,420.35,94.88,420.47Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '93.41947853565216px 420.8203419148922px',
          }}
          id="elaa9ucibik7"
          className="animable"
        />
        <path
          d="M106.47,398.91c.06.1-.48.53-1.26.82s-1.48.33-1.5.22.6-.34,1.34-.63S106.41,398.8,106.47,398.91Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '105.0920352935791px 399.4441508054733px',
          }}
          id="els3z3p3qkb3"
          className="animable"
        />
        <path
          d="M108.12,412.56c-.05.11-.69-.08-1.43-.43s-1.3-.72-1.25-.83.7.09,1.44.43S108.18,412.45,108.12,412.56Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '106.78065252304077px 411.930436193943px',
          }}
          id="elah41i5wu6hi"
          className="animable"
        />
        <path
          d="M111.05,422.34a4.68,4.68,0,0,1-1.9-.51c-1-.39-1.77-.8-1.73-.92a4.65,4.65,0,0,1,1.89.51C110.31,421.81,111.09,422.22,111.05,422.34Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '109.23499369621277px 421.62498474121094px',
          }}
          id="elhp775cc4m4"
          className="animable"
        />
        <path
          d="M95.35,430c-.06-.11.72-.63,1.62-1.34s1.6-1.35,1.69-1.26-.48.86-1.42,1.6A3.85,3.85,0,0,1,95.35,430Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '97.00802433490753px 428.6957542896271px',
          }}
          id="eljloqvj7oru"
          className="animable"
        />
        <path
          d="M103.07,425c-.12,0-.29-.64-.59-1.4s-.6-1.37-.5-1.44.6.45.91,1.28S103.19,425,103.07,425Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '102.55408120155334px 423.5768599510193px',
          }}
          id="ellwpumxv0b4m"
          className="animable"
        />
        <path
          d="M101,413.27c-.07.1-.57-.14-1.12-.53s-.93-.79-.86-.89.57.14,1.12.53S101.1,413.17,101,413.27Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '100.01338636875153px 412.5599820613861px',
          }}
          id="elzlasvdl8xxa"
          className="animable"
        />
        <path
          d="M119,394.85c.07.1-.42.58-1.09,1.07s-1.27.82-1.34.72.41-.57,1.08-1.07S119,394.75,119,394.85Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '117.78494668006897px 395.7448202967644px',
          }}
          id="elo66j7yxky8"
          className="animable"
        />
        <path
          d="M121.75,402.27c0,.12-.75.28-1.69.18s-1.65-.42-1.62-.53.77,0,1.67.09S121.74,402.15,121.75,402.27Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '120.09454011917114px 402.1776606142521px',
          }}
          id="eley1hhbm1jrd"
          className="animable"
        />
        <path
          d="M110.08,403.94c0,.11-.67.36-1.59.42s-1.64-.09-1.63-.21.73-.16,1.61-.22S110.06,403.82,110.08,403.94Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '108.46995735168457px 404.120188832283px',
          }}
          id="elh0b1g3fv5yh"
          className="animable"
        />
        <path
          d="M111.09,396.92c0,.12-.72.14-1.5-.23s-1.23-.9-1.15-1,.62.28,1.33.6S111.1,396.8,111.09,396.92Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '109.76048004627228px 396.33565270900726px',
          }}
          id="elyga47srrc1"
          className="animable"
        />
        <path
          d="M122.75,410.24c-.06.1-.79-.24-1.63-.77s-1.46-1-1.39-1.14.79.25,1.63.77S122.82,410.14,122.75,410.24Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '121.24000430107117px 409.2793268561363px',
          }}
          id="elb5xqkj9aq4u"
          className="animable"
        />
        <rect
          x="88.97"
          y="431.06"
          width="62.25"
          height="11.03"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '120.095px 436.575px',
          }}
          id="elxn9fei3hiph"
          className="animable"
        />
        <polygon
          points="93.62 439.91 101.19 472.88 138.29 472.88 146.57 439.91 93.62 439.91"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '120.09500503540039px 456.39500427246094px',
          }}
          id="elvopoewdajj"
          className="animable"
        />
        <path
          d="M151.19,442.11c0,.12-14,.22-31.36.22s-31.36-.1-31.36-.22,14-.22,31.36-.22S151.19,442,151.19,442.11Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '119.83000183105469px 442.1099853515625px',
          }}
          id="elcfr59pnhyyj"
          className="animable"
        />
        <path
          d="M116.57,404.18c-.1.06-.53-.43-.95-1.11s-.68-1.28-.58-1.34.53.43.95,1.11S116.67,404.11,116.57,404.18Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '115.80500197410583px 402.95499634742737px',
          }}
          id="elgmk86f91x26"
          className="animable"
        />
        <path
          d="M116.59,413.05a3.48,3.48,0,0,1,.33-1.67c.29-.89.63-1.58.74-1.54a3.5,3.5,0,0,1-.33,1.68C117,412.4,116.71,413.09,116.59,413.05Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '117.1251106262207px 411.44498336315155px',
          }}
          id="eluudnhlubch"
          className="animable"
        />
        <path
          d="M119.63,422.37c-.11.06-.57-.69-1-1.66a4.55,4.55,0,0,1-.64-1.85c.11-.06.57.69,1,1.66A4.55,4.55,0,0,1,119.63,422.37Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '118.80999374389648px 420.6149969100952px',
          }}
          id="elocj0m3biixp"
          className="animable"
        />
        <path
          d="M113.06,429.87c-.09-.08.28-.65.83-1.29s1.06-1.08,1.16-1-.28.66-.83,1.29S113.15,430,113.06,429.87Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '114.0562572479248px 428.7306648492813px',
          }}
          id="elqms5p4li6g"
          className="animable"
        />
        <path
          d="M111.68,416.26c0,.12-.62.11-1.34,0s-1.28-.32-1.26-.44.62-.11,1.33,0S111.7,416.14,111.68,416.26Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '110.37999296188354px 416.0400188267231px',
          }}
          id="el846uhs0lfgf"
          className="animable"
        />
      </g>
      <g
        id="freepik--Character--inject-3"
        style={{ transformOrigin: '260.0093994140625px 304.84669494628906px' }}
        className="animable"
      >
        <rect
          x="180.63"
          y="355.24"
          width="147.62"
          height="117.72"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '254.44px 414.1px',
          }}
          id="eldw2j78hv2fc"
          className="animable"
        />
        <g id="el7eujai4qc5r">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '253.27999877929688px 392.49040603637695px',
            }}
            className="animable"
          >
            <path
              d="M191.38,355.48c17.38,6.2,36.55,7.53,55.2,7.88,3.87.07,7.78.06,11.52,1s7.35,3.07,9.27,6.42c2.09,3.65,1.87,8.22.68,12.25s-3.24,7.76-4.72,11.69A43.65,43.65,0,0,0,261,416.53a20.48,20.48,0,0,0,3.08,8.8,10.09,10.09,0,0,0,7.82,4.58c5.61.08,9.45-5.43,12.23-10.31,11.41-20,23.75-42.7,31.05-64.53Z"
              id="elmiaq79hqhjl"
              style={{
                transformOrigin: '253.27999877929688px 392.49040603637695px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M230.93,472.33c-.15,0-.26-26.09-.26-58.27s.11-58.28.26-58.28.26,26.09.26,58.28S231.07,472.33,230.93,472.33Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '230.92999267578125px 414.05499267578125px',
          }}
          id="elbp4voog4ctw"
          className="animable"
        />
        <path
          d="M291.42,268.24c-.44-2.94-9.22-12.64-9.22-12.64s-4.38-17.61-5.7-22.8a17.14,17.14,0,0,0-1.91-4.26,34.25,34.25,0,0,0-12.8-12.35l-12.15-6.83-2.9-6.46-29.18-15-7.91,14S190.44,208,187.9,212.33s1.26,62.8,1.26,62.8-8,33.72-9.73,40.7.54,15.3.54,15.3l14.31-17.95c4.45-5.58,14.21-8.15,21.22-8.05l59.91.27L273,288.62,321.47,298s8.33-16.26,9-16.58S291.42,268.24,291.42,268.24Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '254.62911987304688px 259.5149917602539px',
          }}
          id="eluf3lbvdpqqn"
          className="animable"
        />
        <path
          d="M216.32,207.35c-.42-.43,3.38,12.42,8.16,25.51a64.31,64.31,0,0,1,3.87,22.07v47.4l28.72-1.95-4.29-31.22s-3.5-20.14-4.48-27.8c-.9-7-4-26-4-26S228.35,219.6,216.32,207.35Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '236.67911911010742px 254.83474731445312px',
          }}
          id="elx77wotor3k"
          className="animable"
        />
        <path
          d="M280.06,280a2,2,0,0,1,0-.73,10.49,10.49,0,0,1,.38-1.93,13,13,0,0,1,3.28-5.57,13.17,13.17,0,0,1,5.57-3.3,10.49,10.49,0,0,1,1.93-.38,1.92,1.92,0,0,1,.72,0c0,.09-1,.2-2.54.73a13.84,13.84,0,0,0-8.61,8.63C280.26,279,280.15,280,280.06,280Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '285.9832000732422px 274.02796173095703px',
          }}
          id="elpg4r2mpqlwm"
          className="animable"
        />
        <path
          d="M281.54,268.64a9.26,9.26,0,0,1,4.39-1.27,9,9,0,0,1,4.53.54c0,.16-2-.23-4.49,0S281.6,268.79,281.54,268.64Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '286.00001525878906px 267.97361093759537px',
          }}
          id="elssq275ipz7"
          className="animable"
        />
        <g id="elsc5qaobk8te">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '204.15001678466797px 299.83116483688354px',
            }}
            className="animable"
          >
            <path
              d="M186.27,294.51l-2.5,2.82a20.2,20.2,0,0,0,10.12,6.7,51.52,51.52,0,0,0,12.21,1.1,17.39,17.39,0,0,0,4.94-.47c1.63-.47,3.14-1.39,4.83-1.49a12.33,12.33,0,0,1,3.35.48,6.5,6.5,0,0,0,3.36.05,2.64,2.64,0,0,0,1.95-2.47A176.17,176.17,0,0,0,186.27,294.51Z"
              id="elivxr3w46ha7"
              style={{
                transformOrigin: '204.15001678466797px 299.83116483688354px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M268.27,298.13l-7-7.48L246.72,287s-13.28,4-13.6,4-11.56-3.08-11.56-3.08l-3.93,14.42,20.25,1.39,23.12-.93s1.21-1.12.49-1.89,3.87,1.3,4.41,1.32,1.58.44,2.3-.42C268.69,301.17,269.35,299.28,268.27,298.13Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '243.2415370941162px 295.3650207519531px',
          }}
          id="elbvurj7xz2ww"
          className="animable"
        />
        <path
          d="M261.49,300.86a12.9,12.9,0,0,1-2.3-.66c-1.4-.44-3.35-1-5.52-1.6s-4.17-1-5.62-1.25a11.77,11.77,0,0,1-2.33-.55,10.11,10.11,0,0,1,2.39.18,51.74,51.74,0,0,1,5.68,1.12,48.18,48.18,0,0,1,5.52,1.76A9.43,9.43,0,0,1,261.49,300.86Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '253.60499572753906px 298.8251688480377px',
          }}
          id="elx1lxojvs7tn"
          className="animable"
        />
        <path
          d="M268.27,298.13a31.55,31.55,0,0,1-3.22-1c-2-.66-4.73-1.48-7.8-2.33s-5.79-1.82-7.86-1.94a18.55,18.55,0,0,0-3.34.13,2.72,2.72,0,0,1,.87-.3,9.45,9.45,0,0,1,2.49-.2c2.14,0,5,.91,8,1.81s5.82,1.73,7.78,2.49c1,.37,1.75.71,2.29.95A3,3,0,0,1,268.27,298.13Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '257.15999603271484px 295.3035328388214px',
          }}
          id="elp8a5cmybtjp"
          className="animable"
        />
        <path
          d="M187.9,212.33s-10.45,7.27-13,17.73-13.56,53.21-11.3,59.6,46.2,12.67,46.2,12.67l5.21-22-22.32-6.11s.29-20.35.57-28.78S187.9,212.33,187.9,212.33Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '189.15313148498535px 257.3300094604492px',
          }}
          id="elus5ppzqv86q"
          className="animable"
        />
        <polygon
          points="214.73 283.64 221.92 285.41 217.59 301.99 210.53 300.86 214.73 283.64"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '216.2249984741211px 292.81500244140625px',
          }}
          id="elcm75rpe8z1f"
          className="animable"
        />
        <path
          d="M163.44,287.4s0,.37.11,1a4.87,4.87,0,0,0,1.53,2.49c1.91,1.78,5.56,3.26,10.18,4.09h0c2.11.7,4.52,1.25,7.09,1.83s5.35,1.17,8.27,1.76c5.85,1.2,12.32,2.46,19.18,3.74l-.3.19c.49-2,1-4.19,1.55-6.38,1.23-5,2.43-9.92,3.56-14.55l.18.3L195,276.26h0a19.72,19.72,0,0,0-8.65-1.52,19.17,19.17,0,0,0-6.53,1.54,21.89,21.89,0,0,0-3.75,2.08l-.91.66a1.94,1.94,0,0,1-.32.21s.09-.1.28-.26.48-.41.88-.71a20.22,20.22,0,0,1,3.73-2.19,18.94,18.94,0,0,1,6.6-1.65,19.8,19.8,0,0,1,8.82,1.46h0L215,281.44l.24.06-.06.24c-1.13,4.63-2.32,9.51-3.54,14.56-.54,2.18-1.06,4.34-1.56,6.37l-.06.24-.24,0c-6.86-1.29-13.32-2.57-19.17-3.79-2.92-.61-5.69-1.22-8.27-1.82s-5-1.17-7.12-1.9h0c-4.68-.89-8.33-2.43-10.26-4.3a4.83,4.83,0,0,1-1.5-2.61A3.05,3.05,0,0,1,163.44,287.4Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '189.3201961517334px 288.6449279785156px',
          }}
          id="el0baknw84pw1j"
          className="animable"
        />
        <path
          d="M193.91,275.71c-.06.07-.81-.62-2.15-1.51a20.55,20.55,0,0,0-11.88-3.47c-1.62,0-2.61.22-2.63.13a8.25,8.25,0,0,1,2.61-.49A18.17,18.17,0,0,1,192,273.9,8,8,0,0,1,193.91,275.71Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '185.58000946044922px 273.01865100860596px',
          }}
          id="eledigue88po"
          className="animable"
        />
        <path
          d="M196.84,239.91a8.17,8.17,0,0,1,0,1.34c0,.87-.09,2.11-.21,3.65-.25,3.07-.7,7.3-1.51,11.94a81.5,81.5,0,0,1-2.77,11.72c-.24.73-.5,1.39-.71,2L191,272a6.25,6.25,0,0,1-.69,1.16,6.78,6.78,0,0,1,.5-1.24c.17-.43.35-.92.56-1.46s.41-1.24.63-2a104.6,104.6,0,0,0,2.61-11.7c.8-4.62,1.31-8.83,1.65-11.89.15-1.45.28-2.66.38-3.62A5.68,5.68,0,0,1,196.84,239.91Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '193.58874416351318px 256.5350036621094px',
          }}
          id="elbhnuxhgatta"
          className="animable"
        />
        <path
          d="M222.32,228.58s-.1-.27-.34-.74a4.44,4.44,0,0,0-1.51-1.64,3.74,3.74,0,0,0-3.25-.48,4.18,4.18,0,0,0-2.74,3.11l-.14.71-.31-.66a69.45,69.45,0,0,1-3.05-7.72,40.59,40.59,0,0,1-2.26-13.64c0-.89.12-1.69.17-2.4s.21-1.3.32-1.78a9.33,9.33,0,0,1,.44-1.48,35.5,35.5,0,0,0-.57,5.66A43.63,43.63,0,0,0,211.47,221a77.25,77.25,0,0,0,3,7.68l-.45.06a4.59,4.59,0,0,1,3.09-3.39,4,4,0,0,1,3.53.61,4.34,4.34,0,0,1,1.48,1.81,2.6,2.6,0,0,1,.19.6C222.33,228.5,222.34,228.58,222.32,228.58Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '215.52497243881226px 215.70001220703125px',
          }}
          id="elbmciivjf4qq"
          className="animable"
        />
        <path
          d="M246.7,230.83a7.88,7.88,0,0,1-.23-1.19,12.63,12.63,0,0,1-.21-3.35,7,7,0,0,1,2.41-4.43,4.61,4.61,0,0,1,2.91-1.05,4,4,0,0,1,3.06,1.37l-.44.26-.95-2.39c-1.87-4.71-3.53-9-4.71-12.09l-1.37-3.69a6.92,6.92,0,0,1-.43-1.37,7.84,7.84,0,0,1,.62,1.3c.4,1,.91,2.17,1.53,3.63,1.27,3.07,3,7.32,4.85,12l.94,2.4.61,1.54-1-1.29a3.46,3.46,0,0,0-2.67-1.2,4.15,4.15,0,0,0-2.62.91,6.81,6.81,0,0,0-2.35,4.11,14.19,14.19,0,0,0,.06,3.29A5.06,5.06,0,0,1,246.7,230.83Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '250.75923871994019px 216.86499786376953px',
          }}
          id="eli9lessx61e8"
          className="animable"
        />
        <path
          d="M265.25,233.31c.14,0,2.4,15.18,5.05,33.95s4.67,34,4.53,34-2.4-15.18-5.05-34S265.11,233.33,265.25,233.31Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '270.0399866104126px 267.2850036621094px',
          }}
          id="elg0069rhgx6g"
          className="animable"
        />
        <g id="elt44oa6gx1wg">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '217.34500122070312px 226.97000122070312px',
            }}
            className="animable"
          >
            <path
              d="M211.28,221.32a31.35,31.35,0,0,0,2.49,11.3c1.09-1.35,2.3-2.77,4-3.17,2.06-.49,4.15.78,5.64,2.34a10.23,10.23,0,0,0-1.8-4.32,5.07,5.07,0,0,0-4-2.07,3.5,3.5,0,0,0-3.33,2.72l-2.87-6.73"
              id="elryfe8f552n"
              style={{
                transformOrigin: '217.34500122070312px 226.97000122070312px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M194.39,232.31c-.09,0-.06-1.05-.36-2.68a16.45,16.45,0,0,0-2.43-5.95,17.94,17.94,0,0,0-2.29-2.71,15.38,15.38,0,0,0-2.29-1.79c-1.41-.89-2.4-1.23-2.36-1.32a2.09,2.09,0,0,1,.71.18,4.23,4.23,0,0,1,.81.31,7.66,7.66,0,0,1,1,.52,14,14,0,0,1,2.43,1.74,16.6,16.6,0,0,1,2.39,2.78,14.91,14.91,0,0,1,2.36,6.18,10.09,10.09,0,0,1,.1,2C194.46,232.05,194.43,232.31,194.39,232.31Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '189.56559371948242px 225.08499908447266px',
          }}
          id="elwvcea82azb"
          className="animable"
        />
        <path
          d="M252.44,161a21.43,21.43,0,0,0-21.86-19.15l-1.11,0c-11.95,1-17.77,11.71-16.43,23.62l3.28,41.9,1.39,1.7a22.4,22.4,0,0,0,26.6,6.27h0l-.92-13.48s11.46-2.08,11.3-13.58C254.62,182.7,253.54,171.28,252.44,161Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '233.77136421203613px 179.5865936279297px',
          }}
          id="elzjsjtdyngdc"
          className="animable"
        />
        <path
          d="M243.48,201.83a27.84,27.84,0,0,1-15.17-4s3.75,8.19,15.2,6.86Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '235.91000366210938px 201.33304572105408px',
          }}
          id="el4xgoy933owb"
          className="animable"
        />
        <path
          d="M248.8,170.46a1.66,1.66,0,0,1-1.54,1.7,1.58,1.58,0,0,1-1.73-1.44,1.65,1.65,0,0,1,1.54-1.7A1.57,1.57,0,0,1,248.8,170.46Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '247.1648759841919px 170.58949768543243px',
          }}
          id="elol3bklvnfwe"
          className="animable"
        />
        <path
          d="M249.53,164.21c-.13.2-1.43.34-3,1.18s-2.49,1.89-2.7,1.87,0-.29.39-.76a7.55,7.55,0,0,1,2.1-1.63,6.84,6.84,0,0,1,2.44-.81C249.35,164,249.6,164.11,249.53,164.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '246.64425206184387px 165.65161383152008px',
          }}
          id="elaufqkyr5cn"
          className="animable"
        />
        <path
          d="M232.2,171.33a1.63,1.63,0,0,1-1.54,1.7,1.57,1.57,0,0,1-1.73-1.44,1.65,1.65,0,0,1,1.54-1.7A1.57,1.57,0,0,1,232.2,171.33Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '230.56536424160004px 171.45999228954315px',
          }}
          id="elefvasso6b58"
          className="animable"
        />
        <path
          d="M232,166.62c-.23,0-1.3-.67-3-1.09s-3.11-.33-3.26-.47.18-.2.79-.25a8.49,8.49,0,0,1,2.65.25,7.68,7.68,0,0,1,2.36,1C231.94,166.38,232.06,166.6,232,166.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '228.85929942131042px 165.7064789533615px',
          }}
          id="elmdpss8hm6z"
          className="animable"
        />
        <path
          d="M238.88,180.35a12.32,12.32,0,0,1,2.86-.59c.45,0,.87-.16.94-.47a2.26,2.26,0,0,0-.33-1.32l-1.43-3.41c-2-4.84-3.42-8.83-3.22-8.9s2,3.78,3.93,8.62c.48,1.2.94,2.34,1.37,3.43a2.63,2.63,0,0,1,.28,1.76,1.14,1.14,0,0,1-.73.68,2.88,2.88,0,0,1-.76.13A11.35,11.35,0,0,1,238.88,180.35Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '240.50377011299133px 173.0355043411255px',
          }}
          id="elvi9depkb48q"
          className="animable"
        />
        <path
          d="M232,159.8c-.2.47-1.95.16-4,.3s-3.79.64-4,.19c-.12-.21.2-.65.89-1.08a7,7,0,0,1,6.15-.38C231.7,159.18,232.06,159.57,232,159.8Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '227.9908790588379px 159.38373839855194px',
          }}
          id="el11snomy0xrcd"
          className="animable"
        />
        <path
          d="M249.49,160.19c-.39.41-1.91,0-3.73,0s-3.37.31-3.73-.11c-.16-.2.08-.61.75-1a6.06,6.06,0,0,1,3-.69,6,6,0,0,1,3,.78C249.44,159.58,249.66,160,249.49,160.19Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '245.7636661529541px 159.37967550754547px',
          }}
          id="elws3u0vl1ou"
          className="animable"
        />
        <path
          d="M255.79,150.78a2.19,2.19,0,0,0-2.3-1.77,4.56,4.56,0,0,0,1.58-.81,1.59,1.59,0,0,0,.55-1.6c-.3-.89-1.44-1.08-2.34-1.33a6,6,0,0,1-3-2c-1.09-1.38-1.51-3.18-2.46-4.67A7.63,7.63,0,0,0,236,137.3a7.95,7.95,0,0,0-12.79,1.95,9.27,9.27,0,0,0-12.7,10.15l7.16,4.39a3.87,3.87,0,0,1,4.72-3.36c2.16.63,3.54,3.13,5.78,3.3,1.75.13,3.24-1.22,4.93-1.67,2.05-.55,4.22.27,6.07,1.31s3.62,2.34,5.68,2.86a11.79,11.79,0,0,0,7.29-.87,7.39,7.39,0,0,0,2.7-1.67A3.34,3.34,0,0,0,255.79,150.78Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '233.10232543945312px 145.67666721343994px',
          }}
          id="eltnrif6xuqk"
          className="animable"
        />
        <path
          d="M218.88,150.41l32.8-.18a14.9,14.9,0,0,0-5-5.44,25.6,25.6,0,0,0-15-4.93c-5.35,0-16.05,6.87-19.82,10.66-3,3-2.92,5.59-2.92,5.59-.38,4.26,2.13,9,3.2,13.17.54,2.14,1.67,8.62,1.67,8.62h0c1.8-.05,2.43-1.51,2.11-3.29l-.53-7a10.59,10.59,0,0,0,2.89-12.44C217.83,154.55,216.75,151.66,218.88,150.41Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '230.29061317443848px 158.88001251220703px',
          }}
          id="elmxc7bd829q9"
          className="animable"
        />
        <path
          d="M214.92,167.15c-1.67-5.8-3.21-12-1.43-17.8l-1,0-.4.29a4.59,4.59,0,0,0-5.16,7.07,4,4,0,0,0-4,3.47A7.42,7.42,0,0,0,204,164a8.94,8.94,0,0,1,1.25,3.8,2.85,2.85,0,0,1-2.18,2.95,3.27,3.27,0,0,0,3.71,1.81,6.53,6.53,0,0,1-2.25,2.84c2.14,1.46,5.07,1,7.39-.17a6.3,6.3,0,0,0,3.3-3.06C215.86,170.56,215.38,168.79,214.92,167.15Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '209.22965574264526px 162.83256816864014px',
          }}
          id="elh5r1zarh87e"
          className="animable"
        />
        <path
          d="M214.38,173.92c-.2-.08-8-2.13-7.51,5.72s8.25,5.78,8.25,5.55S214.38,173.92,214.38,173.92Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '210.9839301109314px 179.6131772994995px',
          }}
          id="eldhw5gs1exk5"
          className="animable"
        />
        <path
          d="M213.24,182.34s-.13.1-.36.22a1.35,1.35,0,0,1-1,.08c-.85-.26-1.62-1.53-1.74-2.95a4.56,4.56,0,0,1,.27-2,1.6,1.6,0,0,1,1-1.11.71.71,0,0,1,.83.33c.12.21.07.37.12.39s.16-.15.08-.47a1,1,0,0,0-.34-.47,1,1,0,0,0-.77-.16,1.94,1.94,0,0,0-1.36,1.3,4.86,4.86,0,0,0-.35,2.22c.15,1.58,1,3,2.2,3.28a1.48,1.48,0,0,0,1.23-.28C213.24,182.53,213.27,182.35,213.24,182.34Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '211.42782855033875px 179.60737991333008px',
          }}
          id="elvmqa2z0dwrs"
          className="animable"
        />
        <path
          d="M206.23,167.41s-.22-.3-.15-.92a2.93,2.93,0,0,1,1.47-2,9,9,0,0,1,3.6-.87,4.43,4.43,0,0,0,3.58-1.82,6.53,6.53,0,0,0,.62-4.13c-.19-1.32-.54-2.51-.71-3.54a5.81,5.81,0,0,1,.05-3.37,15.59,15.59,0,0,0,.37,3.28c.22,1,.61,2.17.85,3.56a6.87,6.87,0,0,1-.66,4.52,3.83,3.83,0,0,1-1.87,1.58,8.1,8.1,0,0,1-2.17.48,9.37,9.37,0,0,0-3.45.68,2.92,2.92,0,0,0-1.45,1.72A6.33,6.33,0,0,0,206.23,167.41Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '211.0525164604187px 159.0850067138672px',
          }}
          id="el0fpf93thudqp"
          className="animable"
        />
        <path
          d="M204.33,164s-.17-.22-.24-.71a3.35,3.35,0,0,1,.39-2,3.56,3.56,0,0,1,.93-1.12,4,4,0,0,1,1.51-.7,4.43,4.43,0,0,0,1.49-.62,1.78,1.78,0,0,0,.59-1.44c0-.59-.07-1.22-.05-1.85a9.25,9.25,0,0,1,.2-1.79,8.28,8.28,0,0,1,1.13-2.8,2.16,2.16,0,0,1,1.73-1.11c.52,0,.74.24.72.26s-.26-.09-.7,0a2,2,0,0,0-1.39,1.1,9.12,9.12,0,0,0-.94,2.68,10.09,10.09,0,0,0-.15,1.68c0,.58.09,1.2.06,1.88a2.33,2.33,0,0,1-.83,1.88,4.5,4.5,0,0,1-1.71.69,3.25,3.25,0,0,0-2.22,1.5A4.4,4.4,0,0,0,204.33,164Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '208.3992657661438px 156.9300079345703px',
          }}
          id="elcvh3eq15m3o"
          className="animable"
        />
        <path
          d="M250.29,143.27c.05,0-.59.43-1.62-.05a4.72,4.72,0,0,1-1.49-1.27,6.26,6.26,0,0,0-1.82-1.61,5.43,5.43,0,0,0-5.92.39c-1,.7-1.83,1.69-3,2.51a5.24,5.24,0,0,1-2,.91,4.24,4.24,0,0,1-2.23-.21c-1.42-.51-2.54-1.38-3.76-1.82a10.09,10.09,0,0,0-3.69-.67,9.77,9.77,0,0,0-6,2.05,10.74,10.74,0,0,0-2.8,3.29c-.49.91-.67,1.47-.72,1.45s0-.15.08-.42a8.69,8.69,0,0,1,.42-1.14,10.22,10.22,0,0,1,2.75-3.52,10.06,10.06,0,0,1,6.21-2.27,10.2,10.2,0,0,1,3.91.67c1.32.48,2.46,1.35,3.75,1.8a3.63,3.63,0,0,0,1.92.19,4.62,4.62,0,0,0,1.73-.8c1.05-.75,1.93-1.74,3-2.48a5.66,5.66,0,0,1,3.43-1.13,6.06,6.06,0,0,1,3,.82,6.81,6.81,0,0,1,1.87,1.77,4.51,4.51,0,0,0,1.33,1.28A2.25,2.25,0,0,0,250.29,143.27Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '232.75634765625px 143.69016790390015px',
          }}
          id="eltosdey92j3a"
          className="animable"
        />
        <path
          d="M234.52,182.41c.25,0,.53,1.62,2.17,2.57s3.39.47,3.45.7-.35.4-1.1.54a4.23,4.23,0,0,1-2.86-.48,3.76,3.76,0,0,1-1.72-2.18C234.28,182.87,234.4,182.42,234.52,182.41Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '237.2569935321808px 184.35055768489838px',
          }}
          id="elsnq8vywb2nm"
          className="animable"
        />
        <path
          d="M338,338.66A15.3,15.3,0,0,0,327,335l-6.76,21.47c4.95.22,9.89,2.77,14.67,1.46a10.47,10.47,0,0,0,7.29-8.6A12.43,12.43,0,0,0,338,338.66Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '331.25392150878906px 346.6338129043579px',
          }}
          id="ela1y58skd3y9"
          className="animable"
        />
        <path
          d="M327.08,334.51c0-.17.73-.31,2-.3a16.7,16.7,0,0,1,5.53,1.05,15,15,0,0,1,6.74,5.23,13.93,13.93,0,0,1,2.25,4.66,12.26,12.26,0,0,1,.16,5.63,11.45,11.45,0,0,1-2.45,5.13,10.83,10.83,0,0,1-4.36,3,15.67,15.67,0,0,1-8.5.55,25.67,25.67,0,0,1-5.3-1.65c-1.19-.51-1.82-.89-1.76-1.06s.78-.12,2,.09,3.07.6,5.27.8a15.25,15.25,0,0,0,7.35-1,8.75,8.75,0,0,0,3.3-2.44,9.22,9.22,0,0,0,1.86-4,11,11,0,0,0-1.83-8.4,14.49,14.49,0,0,0-5.5-4.92,24.85,24.85,0,0,0-4.93-1.72C327.76,334.9,327.06,334.69,327.08,334.51Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '332.6993246078491px 347.0079288482666px',
          }}
          id="el2nagh8tl4jj"
          className="animable"
        />
        <path
          d="M264.45,415.06l-14.7,41.19L300.9,474.8c1.48-5-21.43-24.4-21.43-24.4l10.5-26Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '275.359375px 444.92999267578125px',
          }}
          id="elo7udk6fwh4l"
          className="animable"
        />
        <g id="elilaclyrz3he">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '264.27563738822937px 444.510511636734px',
            }}
            className="animable"
          >
            <path
              d="M264.46,442.45a2.22,2.22,0,0,0-2.31,1.86,2.13,2.13,0,0,0,1.82,2.3,2.34,2.34,0,0,0,2.44-2c0-1.09-1.08-2.34-2.16-2.19"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '264.27563738822937px 444.510511636734px',
              }}
              id="elnc0ey948jti"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M249.75,456.25l1.49-4.15,48.58,19.38s1.92,1.81,1.08,3.32Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '275.4313144683838px 463.45001220703125px',
          }}
          id="elezkn3tw6ub7"
          className="animable"
        />
        <path
          d="M280.4,450.44c-.1.25-1.39-.09-2.91.27s-2.56,1.17-2.75,1,.7-1.49,2.55-1.89S280.53,450.23,280.4,450.44Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '277.56163358688354px 450.72185826301575px',
          }}
          id="el1h8k2s0pedxi"
          className="animable"
        />
        <path
          d="M285,454.61c0,.26-1.27.29-2.5,1s-1.88,1.78-2.13,1.68.11-1.57,1.66-2.48S285,454.37,285,454.61Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '282.6487522125244px 455.7847908735275px',
          }}
          id="eloea1nw5txf"
          className="animable"
        />
        <path
          d="M285.67,462.13c-.24,0-.14-1.4,1-2.54s2.5-1.25,2.53-1-.95.71-1.87,1.66S285.93,462.2,285.67,462.13Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '287.38220739364624px 460.3064045906067px',
          }}
          id="elvg016u3lieq"
          className="animable"
        />
        <path
          d="M282.13,444.25c-.19.19-1.21-.57-2.65-1s-2.71-.37-2.76-.63,1.32-.77,3-.25S282.33,444.1,282.13,444.25Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '279.4377613067627px 443.2125720977783px',
          }}
          id="elplcdzwpf97"
          className="animable"
        />
        <path
          d="M283.11,437.74a5.18,5.18,0,0,1-2.55-.94,11.73,11.73,0,0,1-2.38-1.8,12.63,12.63,0,0,1-1.19-1.31,3.43,3.43,0,0,1-.56-.88,1.15,1.15,0,0,1,.37-1.37,1.47,1.47,0,0,1,1.3-.18,3.67,3.67,0,0,1,.91.48,10,10,0,0,1,1.4,1.13,9.56,9.56,0,0,1,1.8,2.4,4.55,4.55,0,0,1,.75,2.63c-.14,0-.44-.95-1.31-2.3a11.18,11.18,0,0,0-1.82-2.11,10.44,10.44,0,0,0-1.31-1c-.49-.34-.95-.51-1.17-.32s-.11.11-.05.31a2.62,2.62,0,0,0,.41.65,12.21,12.21,0,0,0,1.07,1.26,14.66,14.66,0,0,0,2.13,1.85C282.23,437.19,283.17,437.61,283.11,437.74Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '279.7256636619568px 434.5415098667145px',
          }}
          id="elwhvmub3tcx"
          className="animable"
        />
        <path
          d="M282.66,438a4.4,4.4,0,0,1,.22-2.72,9,9,0,0,1,1.37-2.68,9.84,9.84,0,0,1,1.21-1.32,2.29,2.29,0,0,1,2.11-.7,1.29,1.29,0,0,1,.81,1.11,3.72,3.72,0,0,1-.08,1,6.2,6.2,0,0,1-2.68,4c-1.48,1-2.63.88-2.62.79s1-.32,2.24-1.32a6.32,6.32,0,0,0,1.68-2.11,5.62,5.62,0,0,0,.49-1.5c.12-.57.07-1.09-.15-1.1a1.53,1.53,0,0,0-1.2.51,8.89,8.89,0,0,0-1.14,1.16,9.51,9.51,0,0,0-1.42,2.37C282.88,437,282.81,438,282.66,438Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '285.46256470680237px 434.2701268196106px',
          }}
          id="elkkfs3spl4a"
          className="animable"
        />
        <path
          d="M214.9,305.06c-7.76.18-15.12,1.27-20.47,6.9-7.09,7.47-15.85,18.1-16.35,25.47-.74,11,5.91,14.3,10.76,17a13.62,13.62,0,0,0,7,1.63l89.68-.68,2.81-15.19-58-14.3,2.41-21.83Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '233.17658615112305px 330.06500244140625px',
          }}
          id="elneq6w89mwk"
          className="animable"
        />
        <path
          d="M232.79,304.05l28.21-1.3s48.74,2.71,59.13,12.24,9.1,20.36,5.63,30.75-34,76.88-34,76.88,2.48,4.23,1.09,8.45a11.15,11.15,0,0,1-8,7.58l-27.12-10s-3.68-1.3-1.08-4.77,4.33-4.11,4.33-4.11v-6.93s9.53-17.33,10.39-19.71,10-37.64,10-37.64l6.07-10.43s-14.67-6.9-27.39-11.9l-29.7-7.32Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '279.3124694824219px 370.7000274658203px',
          }}
          id="elb528lhhq9sa"
          className="animable"
        />
        <path
          d="M278.55,427.43a26.64,26.64,0,0,1-2.38-1.56,32.21,32.21,0,0,0-12.66-4.81,27.93,27.93,0,0,1-2.82-.42,10.82,10.82,0,0,1,2.86.05,27,27,0,0,1,12.83,4.88A10.88,10.88,0,0,1,278.55,427.43Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '269.61997985839844px 423.99919390678406px',
          }}
          id="elfxkvz6n57de"
          className="animable"
        />
        <path
          d="M292.1,422.67a9.05,9.05,0,0,1-1.57-1.66c-.92-1.07-2.14-2.59-3.41-4.33s-2.37-3.35-3.12-4.54a10.23,10.23,0,0,1-1.12-2,10.5,10.5,0,0,1,1.42,1.79l3.24,4.44c1.21,1.64,2.32,3.12,3.28,4.41A10.49,10.49,0,0,1,292.1,422.67Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '287.49000549316406px 416.405029296875px',
          }}
          id="ele8yoidzd066"
          className="animable"
        />
        <path
          d="M302,335.58c0,.08-1,.3-2.57.82a27,27,0,0,0-10.86,6.78,26.9,26.9,0,0,1-1.87,1.95,9.32,9.32,0,0,1,1.6-2.2,22.83,22.83,0,0,1,5-4.23,22.56,22.56,0,0,1,6-2.65A9.09,9.09,0,0,1,302,335.58Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '294.3499755859375px 340.35498046875px',
          }}
          id="ela3a7uvhpywa"
          className="animable"
        />
        <path
          d="M274.3,382.66a2.38,2.38,0,0,1,.11-.59l.42-1.65,1.62-6.05L282,354.46c1.13-3.89,2.09-7.59,3.18-10.95a22.87,22.87,0,0,1,5.11-7.79,29.28,29.28,0,0,1,4.84-4c.63-.4,1.12-.7,1.47-.88a3.18,3.18,0,0,1,.53-.27s-.68.46-1.88,1.31a32.48,32.48,0,0,0-4.7,4.09,22.87,22.87,0,0,0-4.92,7.7c-1,3.31-2,7.06-3.13,10.93l-5.69,19.86c-.74,2.49-1.35,4.52-1.79,6-.21.66-.37,1.2-.51,1.62A2.29,2.29,0,0,1,274.3,382.66Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '285.71498107910156px 356.61500549316406px',
          }}
          id="elv4mdcca8c3o"
          className="animable"
        />
        <path
          d="M249.35,331.87c-.15,0-.74-5.26-1.33-11.78s-1-11.82-.8-11.83.73,5.26,1.32,11.78S249.49,331.86,249.35,331.87Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '248.27447247505188px 320.06500911712646px',
          }}
          id="elqwi2irl1v7j"
          className="animable"
        />
        <path
          d="M202.39,346c-.08,0-.51-.81-1.4-2.06a20.7,20.7,0,0,0-4.09-4.31,21,21,0,0,0-5.17-2.93c-1.43-.56-2.36-.77-2.34-.86a8,8,0,0,1,2.46.51,17.75,17.75,0,0,1,9.45,7.38A7.7,7.7,0,0,1,202.39,346Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '195.8898525238037px 340.9200134277344px',
          }}
          id="ele4qzrqgka3u"
          className="animable"
        />
        <path
          d="M219.67,326.8c0,.08-1.24-.68-3.31-1.63A31.24,31.24,0,0,0,199,322.69c-2.25.32-3.62.72-3.64.63a3.45,3.45,0,0,1,.93-.36,21.64,21.64,0,0,1,2.65-.64,28.52,28.52,0,0,1,17.56,2.52,21.18,21.18,0,0,1,2.36,1.36A3.63,3.63,0,0,1,219.67,326.8Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '207.51499938964844px 324.34824776649475px',
          }}
          id="elloonq1gmmbl"
          className="animable"
        />
        <path
          d="M287.23,340.16a3.07,3.07,0,0,1-.71-.12l-2-.43L277.22,338c-6.17-1.38-14.71-3.24-24.18-5.11s-18.07-3.42-24.3-4.49l-7.39-1.27-2-.35a2.86,2.86,0,0,1-.69-.17,6.3,6.3,0,0,1,.71.06l2,.26c1.75.24,4.28.62,7.41,1.11,6.25,1,14.87,2.46,24.35,4.34s18,3.79,24.16,5.26c3.07.74,5.56,1.36,7.27,1.81l2,.52A3.86,3.86,0,0,1,287.23,340.16Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '252.94500732421875px 333.38499450683594px',
          }}
          id="el4s4s14isgtg"
          className="animable"
        />
        <path
          d="M230.38,328.45c-.1,0-.31-1.18-1.24-2.86a12.33,12.33,0,0,0-2-2.65,32.53,32.53,0,0,0-3.14-2.72,47.51,47.51,0,0,0-6.43-4,21.42,21.42,0,0,1-2.74-1.56,16.89,16.89,0,0,1,2.91,1.23,37.58,37.58,0,0,1,6.58,3.91,29.45,29.45,0,0,1,3.16,2.79,11.59,11.59,0,0,1,2,2.81,9.55,9.55,0,0,1,.81,2.2A2.32,2.32,0,0,1,230.38,328.45Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '222.60870885849px 321.5550079345703px',
          }}
          id="el6r4h99uu3n"
          className="animable"
        />
        <path
          d="M330.27,342c.11.12-1.39,1.63-2.56,3.94s-1.55,4.39-1.7,4.36a9.08,9.08,0,0,1,1.24-4.6A9.19,9.19,0,0,1,330.27,342Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '328.14282155036926px 346.1501545906067px',
          }}
          id="elg5ztvr26kh6"
          className="animable"
        />
        <g id="elmnfvrf7avzk">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '269.67337441444397px 262.50999450683594px',
            }}
            className="animable"
          >
            <path
              d="M266.08,239.54l6.42,45.22.32.72A97,97,0,0,0,266.08,239.54Z"
              id="elr2ph9nwb3ii"
              style={{
                transformOrigin: '269.67337441444397px 262.50999450683594px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M300.65,265.52,279.78,302l-51.43,1.12-.13,2.33,49.8-.37,1.58-.06,52.58.11,10.63-18.33,13.58-19.46a1.92,1.92,0,0,0-1.59-3l-52.49.2A1.92,1.92,0,0,0,300.65,265.52Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '292.4712677001953px 284.8949890136719px',
          }}
          id="el6aysu94obrb"
          className="animable"
        />
        <path
          d="M342.81,286.83s2.7,2.48,2.28,4.58-.29,3.67-2.28,3.81a3,3,0,0,1-2.7,3.13s.61,3.3-3.23,3.87c0,0-1.18,3.53-3.6,2.67a20.93,20.93,0,0,1-4-1.85l-.71-1.28s-3.57-1.34-2.69-3.35c.54-1.22,2.38-1.54,2.38-1.54a3.43,3.43,0,0,1,.23-3.12c.85-1.15,3.63-.2,3.63-.2a3.94,3.94,0,0,1,.88-2.72c1-1.13,5.38,1.92,5.38,1.92l2.41-2.88Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '335.43741607666016px 295.92748641967773px',
          }}
          id="elzc5z7ojrtu"
          className="animable"
        />
        <path
          d="M336.88,302.22a25,25,0,0,1-4.44-2.45,24.33,24.33,0,0,1-4.16-2.9,25.51,25.51,0,0,1,4.44,2.46A25.16,25.16,0,0,1,336.88,302.22Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '332.58001708984375px 299.5449981689453px',
          }}
          id="elb5xbgssp4uu"
          className="animable"
        />
        <path
          d="M340.11,298.35a20.83,20.83,0,0,1-4.12-2.18,21.15,21.15,0,0,1-3.85-2.62,20.2,20.2,0,0,1,4.12,2.18A21.15,21.15,0,0,1,340.11,298.35Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '336.12498474121094px 295.95001220703125px',
          }}
          id="eloj6s5fozcpo"
          className="animable"
        />
        <path
          d="M335.71,291.11c.08-.15,1.73.72,3.65,1.94a32.68,32.68,0,0,1,3.43,2.28c-.07.17-1.79-.61-3.71-1.84A19.59,19.59,0,0,1,335.71,291.11Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '339.24998474121094px 293.22317576408386px',
          }}
          id="elajldqmiifth"
          className="animable"
        />
        <path
          d="M356.39,265.74a.79.79,0,0,1-.25,0l-.74,0-2.84,0-10.44.08-34.45.08h-2.51a2.07,2.07,0,0,0-1.91.9q-1.2,2.14-2.34,4.22l-4.44,8-7.53,13.53c-2.14,3.82-3.89,6.92-5.12,9.11-.59,1-1.07,1.86-1.41,2.46l-.38.63-.14.21s0-.09.09-.24l.34-.66,1.33-2.5,5-9.19,7.44-13.59c1.4-2.55,2.88-5.23,4.4-8l2.35-4.25a2.6,2.6,0,0,1,2.35-1.14h2.51l34.45.07,10.44.09,2.84.05.74,0A.79.79,0,0,1,356.39,265.74Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '319.1400146484375px 285.1712875366211px',
          }}
          id="elqm21tca3nc9"
          className="animable"
        />
        <path
          d="M319.39,284.09a2.22,2.22,0,1,0,3.31-.39A2.37,2.37,0,0,0,319.39,284.09Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '321.21660923957825px 285.38513445854187px',
          }}
          id="el2ov2q7dhtvv"
          className="animable"
        />
        <g id="elw729d0rwhd">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '181.45999908447266px 270.9784457683563px',
            }}
            className="animable"
          >
            <path
              d="M173.39,270c-.44.18-.95.48-.95,1a.86.86,0,0,0,.73.78,9.29,9.29,0,0,0,2.14-.57c5.41-1.19,9.86-.05,15,2l.17-.17C188.44,268.61,179.21,267.63,173.39,270Z"
              id="elejh4xo2npn8"
              style={{
                transformOrigin: '181.45999908447266px 270.9784457683563px',
              }}
              className="animable"
            />
          </g>
        </g>
      </g>
      <g
        id="freepik--Floor--inject-3"
        style={{ transformOrigin: '250px 473px' }}
        className="animable"
      >
        <path
          d="M452,473c0,.14-90.45.26-202,.26S48,473.1,48,473s90.43-.26,202-.26S452,472.81,452,473Z"
          style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '250px 473px' }}
          id="el53ul8vrauyf"
          className="animable"
        />
      </g>
      <g
        id="freepik--Ribbon--inject-3"
        style={{ transformOrigin: '233.8699951171875px 114.45518493652344px' }}
        className="animable animator-hidden"
      >
        <path
          d="M145.42,154.21c.17.17,33.38-11.24,33.38-11.24L166,113.67,136.47,125l16.26,9.34Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '157.63500213623047px 133.94094276428223px',
          }}
          id="el9rilnrj63fw"
          className="animable"
        />
        <path
          d="M161,122.49V82.6s45.81-8.38,78.82-7.88,67,5.91,67,5.91v38.3S203.36,109.69,161,122.49Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '233.91000366210938px 98.59424209594727px',
          }}
          id="eluotbtjig7c"
          className="animable"
        />
        <path
          d="M160.76,122.53l18,20.61V118.93S163.71,120.73,160.76,122.53Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '169.75999450683594px 131.0349998474121px',
          }}
          id="elpifcbs2814c"
          className="animable"
        />
        <path
          d="M161,82.59c.15,0,.21,9,.15,20s-.24,20-.38,20-.21-8.94-.15-20S160.85,82.59,161,82.59Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '160.8857069015503px 102.58999633789062px',
          }}
          id="el2j51ymophzp"
          className="animable"
        />
        <path
          d="M322.32,151.15c-.17.17-33.38-11.24-33.38-11.24l12.77-29.31,29.56,11.31L315,131.25Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '310.10499572753906px 130.87593269348145px',
          }}
          id="eltdwtv8fbo3"
          className="animable"
        />
        <path
          d="M307,119.47l-18,20.61V117.62A132.76,132.76,0,0,1,307,119.47Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '298px 128.85000228881836px',
          }}
          id="elt931kr4kh1a"
          className="animable"
        />
        <path
          d="M306.8,80.63c.14,0,.3,8.69.35,19.42s0,19.42-.17,19.42-.3-8.69-.35-19.42S306.65,80.63,306.8,80.63Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '306.8911964595318px 100.04999542236328px',
          }}
          id="elfjvd2y9z0vd"
          className="animable"
        />
        <path
          d="M186.83,100.09a5.86,5.86,0,0,1,9.57-5L195,96.77a3.46,3.46,0,0,0-2.82-.87,3.41,3.41,0,0,0,.94,6.76,3.42,3.42,0,0,0,2.48-1.62l1.76,1.23a5.85,5.85,0,0,1-10.56-2.18Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '192.07998657226562px 99.27813005447388px',
          }}
          id="elcs9z52ji0gs"
          className="animable"
        />
        <path
          d="M197.74,98.59a5.84,5.84,0,1,1,6.36,4.88A5.52,5.52,0,0,1,197.74,98.59Zm9.11-.94a3.33,3.33,0,1,0-3,3.73A3.25,3.25,0,0,0,206.85,97.65Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '203.50556993484497px 97.67963027954102px',
          }}
          id="elfszlyks1wc"
          className="animable"
        />
        <path
          d="M221.31,101.92l-.43-6.38L218.09,101l-1.1.07-3.45-4.92.41,6.24-2.31.15L211,91.91l2-.13,4.4,6.35,3.49-6.85,2-.13.72,10.62Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '217.30500030517578px 96.84500503540039px',
          }}
          id="el954yedl0c4"
          className="animable"
        />
        <path
          d="M235.08,94.64c.06,2.38-1.68,3.9-4.52,4l-2.15.06.09,2.94-2.47.07L225.73,91l4.61-.13C233.19,90.83,235,92.26,235.08,94.64Zm-2.5.07c0-1.17-.81-1.83-2.32-1.79l-2,.06.11,3.7,2-.06C231.87,96.58,232.61,95.87,232.58,94.71Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '230.4057502746582px 96.28959321975708px',
          }}
          id="elaiwo4b1oizr"
          className="animable"
        />
        <path
          d="M237,90.77h2.46v8.64h5.34v2H237Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '240.9000015258789px 96.08999633789062px',
          }}
          id="elr8awa1hzeyo"
          className="animable"
        />
        <path
          d="M254.35,99.72l0,2-8.25-.24.31-10.65,8,.24-.06,2-5.6-.17-.06,2.32,4.94.14-.06,1.92-4.94-.15-.07,2.47Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '250.2550048828125px 96.2750015258789px',
          }}
          id="elnxr3jbc8zj"
          className="animable"
        />
        <path
          d="M258.91,93.3l-3.4-.2.12-2,9.26.56-.12,2-3.4-.21-.52,8.63-2.46-.15Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '260.20001220703125px 96.59000396728516px',
          }}
          id="eldh2912znxxo"
          className="animable"
        />
        <path
          d="M273.86,101.18l-.18,2-8.22-.76,1-10.6,8,.74-.18,2L268.7,94l-.21,2.31,4.92.45-.17,1.91-4.93-.45-.22,2.45Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '269.9599914550781px 97.5px',
          }}
          id="el5k5n0dxuwz6"
          className="animable"
        />
        <path
          d="M276.94,92.79l4.79.64c3.45.46,5.54,2.85,5.12,6s-3.08,5-6.53,4.5l-4.79-.64Zm3.53,9.17a3.3,3.3,0,1,0,.87-6.54l-2.23-.3-.87,6.54Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '281.2167053222656px 98.40054988861084px',
          }}
          id="elrvg6oim93v"
          className="animable"
        />
      </g>
      <g
        id="freepik--Confetti--inject-3"
        style={{ transformOrigin: '240.1550064086914px 109.69999694824219px' }}
        className="animable"
      >
        <polygon
          points="327.29 84.26 329.91 87.33 337.29 84.26 335.13 81.03 327.29 84.26"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '332.2900085449219px 84.18000030517578px',
          }}
          id="eloh6i1w6h3wp"
          className="animable"
        />
        <path
          d="M323.91,69.65a3.84,3.84,0,1,1-3.84-3.84A3.85,3.85,0,0,1,323.91,69.65Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '320.0700225830078px 69.64999771118164px',
          }}
          id="elcecfp02bys9"
          className="animable"
        />
        <path
          d="M237.89,126.93A1.92,1.92,0,1,1,236,125,1.92,1.92,0,0,1,237.89,126.93Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '235.97001111507416px 126.91978991031647px',
          }}
          id="elmee4hjphu0p"
          className="animable"
        />
        <path
          d="M148.44,98.07A1.46,1.46,0,1,1,147,96.61,1.46,1.46,0,0,1,148.44,98.07Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '146.9799793958664px 98.06988954544067px',
          }}
          id="elf75cq351ah"
          className="animable"
        />
        <polygon
          points="143.02 82 147.32 82.26 149.36 73.8 145.34 73.97 143.02 82"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '146.19000244140625px 78.03000259399414px',
          }}
          id="ele5z1sfn82et"
          className="animable"
        />
        <polygon
          points="277.42 149.53 278.87 153.59 287.45 152.15 285.72 148.52 277.42 149.53"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '282.4350128173828px 151.05500030517578px',
          }}
          id="elgb0x8y8mj6u"
          className="animable"
        />
        <polygon
          points="190.64 126.1 187.99 129.5 193.8 135.97 195.94 132.56 190.64 126.1"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '191.96500396728516px 131.0349998474121px',
          }}
          id="elncrwrxn2kd"
          className="animable"
        />
      </g>
      <g
        id="freepik--Stars--inject-3"
        style={{ transformOrigin: '232.98999786376953px 55.42500114440918px' }}
        className="animable animator-hidden"
      >
        <polygon
          points="180.37 46.23 190.52 56.58 204.81 51.18 205.38 54.73 199.19 67.4 204.9 76.86 204.42 79.69 190.59 77.36 182.41 86.33 180.49 84.88 178.8 73.47 165.9 66.75 165.33 64.14 178.32 60.59 180.37 46.23"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '185.3550033569336px 66.28000068664551px',
          }}
          id="ell0taf3kd4u"
          className="animable"
        />
        <g id="eldwuz51x16rg">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '185.3550033569336px 66.28000068664551px',
            }}
            className="animable"
          >
            <polygon
              points="180.37 46.23 190.52 56.58 204.81 51.18 205.38 54.73 199.19 67.4 204.9 76.86 204.42 79.69 190.59 77.36 182.41 86.33 180.49 84.88 178.8 73.47 165.9 66.75 165.33 64.14 178.32 60.59 180.37 46.23"
              id="elgq6runv7czr"
              style={{
                transformOrigin: '185.3550033569336px 66.28000068664551px',
              }}
              className="animable"
            />
          </g>
        </g>
        <polygon
          points="180.37 43.32 190.52 53.68 204.81 51.18 198.1 64.04 204.9 76.86 190.59 74.46 180.49 84.88 178.36 70.53 165.33 64.14 178.32 57.68 180.37 43.32"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '185.11499786376953px 64.0999984741211px',
          }}
          id="ely8lijbw8vv"
          className="animable"
        />
        <polygon
          points="285.62 46.23 275.46 56.58 261.17 51.18 260.6 54.73 266.79 67.4 261.08 76.86 261.56 79.69 275.39 77.36 283.57 86.33 285.49 84.88 287.18 73.47 300.08 66.75 300.65 64.14 287.66 60.59 285.62 46.23"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '280.625px 66.28000068664551px',
          }}
          id="elj4h1ve0ky7o"
          className="animable"
        />
        <g id="eliba863dq2yc">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '280.625px 66.28000068664551px',
            }}
            className="animable"
          >
            <polygon
              points="285.62 46.23 275.46 56.58 261.17 51.18 260.6 54.73 266.79 67.4 261.08 76.86 261.56 79.69 275.39 77.36 283.57 86.33 285.49 84.88 287.18 73.47 300.08 66.75 300.65 64.14 287.66 60.59 285.62 46.23"
              id="eld5sbrl340j"
              style={{ transformOrigin: '280.625px 66.28000068664551px' }}
              className="animable"
            />
          </g>
        </g>
        <polygon
          points="285.62 43.32 275.46 53.68 261.17 51.18 267.88 64.04 261.08 76.86 275.39 74.46 285.49 84.88 287.62 70.53 300.65 64.14 287.66 57.68 285.62 43.32"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '280.864990234375px 64.0999984741211px',
          }}
          id="el85sr5rriw4v"
          className="animable"
        />
        <polygon
          points="232.66 28.06 241.11 44.57 260.6 43.42 259.94 47.96 247.56 61.07 250.91 74.78 249.26 78.05 233.27 69.94 219.88 77.78 218.09 75.27 220.37 60.7 207.19 47.59 207.49 44.2 224.69 44.81 232.66 28.06"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '233.89500427246094px 53.055002212524414px',
          }}
          id="el74obx2jaxne"
          className="animable"
        />
        <g id="eli5nykja0cbi">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '233.89500427246094px 53.055002212524414px',
            }}
            className="animable"
          >
            <polygon
              points="232.66 28.06 241.11 44.57 260.6 43.42 259.94 47.96 247.56 61.07 250.91 74.78 249.26 78.05 233.27 69.94 219.88 77.78 218.09 75.27 220.37 60.7 207.19 47.59 207.49 44.2 224.69 44.81 232.66 28.06"
              id="elhxqq9t6m4ga"
              style={{
                transformOrigin: '233.89500427246094px 53.055002212524414px',
              }}
              className="animable"
            />
          </g>
        </g>
        <polygon
          points="233.76 24.52 242.21 41.02 260.6 43.42 247.51 56.56 250.91 74.78 234.38 66.4 218.09 75.27 220.96 56.95 207.49 44.2 225.8 41.26 233.76 24.52"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '234.04500579833984px 49.89499855041504px',
          }}
          id="eld0lv01y1t6"
          className="animable"
        />
      </g>
      <g
        id="freepik--speech-bubble--inject-3"
        style={{ transformOrigin: '304.6501007080078px 193.23003387451172px' }}
        className="animable"
      >
        <path
          d="M267.43,172.63l14.12,1.56a33.1,33.1,0,1,1-5,10.77v0Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '304.56028747558594px 193.2884864807129px',
          }}
          id="el72tnulndb5x"
          className="animable"
        />
        <path
          d="M267.43,172.63c.55.74,3.41,4.52,9.25,12.27h-.21a.12.12,0,0,1,.18-.05.13.13,0,0,1,.06.14,32.87,32.87,0,0,0,.22,17.07,28.83,28.83,0,0,0,1.83,4.86c.4.8.78,1.62,1.21,2.43l1.49,2.37a33.09,33.09,0,0,0,20.14,13.53,32.7,32.7,0,0,0,13.76.06,33.33,33.33,0,0,0,13.17-6.1,32.08,32.08,0,0,0,9.55-11.73,32.7,32.7,0,0,0,3.28-15.08,33.34,33.34,0,0,0-3.7-14.32,32.22,32.22,0,0,0-8.94-10.78,33.19,33.19,0,0,0-23.65-6.76,35.89,35.89,0,0,0-10.35,2.86,33,33,0,0,0-13.07,10.86.1.1,0,0,1-.11.05l-14.11-1.68,14.14,1.43-.12.06a32.83,32.83,0,0,1,13.12-11A35.47,35.47,0,0,1,305,160.14a33.55,33.55,0,0,1,24,6.78,32.53,32.53,0,0,1,9.09,10.93,33.59,33.59,0,0,1,3.77,14.54,33.21,33.21,0,0,1-3.32,15.32,32.62,32.62,0,0,1-9.71,11.91,33.87,33.87,0,0,1-13.38,6.18,33,33,0,0,1-14-.09A33.36,33.36,0,0,1,281.12,212l-1.5-2.4c-.43-.82-.81-1.66-1.22-2.47a29.36,29.36,0,0,1-1.82-4.92,32.93,32.93,0,0,1-.12-17.23l.24.09v0a.14.14,0,0,1-.18.05l0,0Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '304.6501007080078px 193.23003768920898px',
          }}
          id="el9d0fnn3la7v"
          className="animable"
        />
        <path
          d="M296.4,181.44a3.09,3.09,0,0,1,0,.46c0,.33,0,.75,0,1.28,0,1.16,0,2.77.06,4.81,0,4.15.07,10,.12,17l-.23-.23,23.53,0c.06-.06-.49.49-.26.25h0v-3.2c0-1.05,0-2.1,0-3.14v-6.09c0-3.94,0-7.67,0-11.1l.22.23-17-.12-4.81-.05-1.28,0-.46,0,.41,0,1.24,0,4.75-.06,17.13-.11h.23v.22c0,3.43,0,7.16,0,11.1V205h0c.24-.23-.31.33-.26.27l-23.53,0h-.23V205c0-7.06.08-12.95.11-17.13,0-2,0-3.62.06-4.76,0-.51,0-.92,0-1.24A1.77,1.77,0,0,1,296.4,181.44Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '308.0704355239868px 193.32227230072021px',
          }}
          id="el81bvwddbebo"
          className="animable"
        />
        <path
          d="M317.39,185.33c.34.27-2.82,4.83-7.07,10.19-.84,1.07-1.67,2.09-2.44,3l-.5.61-.56-.51c-3.68-3.31-6.17-5.85-5.95-6.11s3.11,1.84,6.92,5l-1.07.1c.73-1,1.53-2,2.38-3.06C313.34,189.19,317.06,185.07,317.39,185.33Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '309.13579273223877px 192.22417497634888px',
          }}
          id="el9jgi9jw52z"
          className="animable"
        />
      </g>
      <defs>
        <filter id="active" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="hover" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#ff0000" floodOpacity="0.5" result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
          <feColorMatrix
            type="matrix"
            values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
          />
        </filter>
      </defs>
    </svg>
  );
};

export default PaymentIcon;

PaymentIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
